import { API_BASE } from "../../util/AppUtil";

export const FORMAPI_BASE = API_BASE + '/merchant/equipment';